import _ from 'lodash';
import environment from '../environment';
import api from '../api';
import dataBoard from '../core/databoard';
import infoBoard from '../core/infoboard';
import translate, { translateText } from '../core/tools/translate';
import { notify, NOTIFY_TYPE } from '../shared/notify';
import ShapesInfo from './ShapesInfo';
import numeral from 'numeral';
import moment from 'moment';

const LayerControls = (name) => require('../controls').get(name);

class DncFlexibleInfo extends ShapesInfo {
    constructor() {
        const name = 'DncFlexible';

        const options = {
            layer: LayerControls(name).getLayer(),
            label: translate(`Common.UnmetDemand`),
            name: name,
            id: 'dncflexible'
        };

        super(options);
    }

    static getInstance() {
        if (!DncFlexibleInfo._instance) {
            DncFlexibleInfo._instance = new DncFlexibleInfo();
        }

        return DncFlexibleInfo._instance;
    }

    _getContainer() {
        return infoBoard.createContainer({
            id: this.options.name,
            name: this.options.label,
            visible: false,
            actions: true
        });
    }

    _hasActions() {
        return false;
    }

    _hasSummary() {
        return true;
    }

    _setSummary(options, feature, entries) {
        if (_.size(entries) === 0 && !feature) {
            return notify(NOTIFY_TYPE.ERROR, translate('Error.NoDataAvailable'));
        }

        entries = entries.filter(e => $(`#DncFlexible-selection-${e.Id}`).prop('checked'));

        if (_.size(entries) === 0 && !feature) {
            return notify(NOTIFY_TYPE.ERROR, translate('Error.NoDataAvailable'));
        }

        if (feature) {
            options.subtitle = feature.properties.Nome;
            options.id = [feature.properties.Id];
        } else {
            options.id = _.map(entries, e => e.Id);
            if (_.size(entries) === 1) {
                options.subtitle = entries[0].Nome;
            } else {
                options.subtitle = `${_.size(entries)} ${translate('Common.SelectedLocation')}`;
            }
        }

        const _success = res => {
            if (!_.size(res)) {
                return notify(NOTIFY_TYPE.ERROR, translate('Error.NoDataAvailable'));
            }

            const period = {
                start: moment(res[0].DncValues[0].getInitialDate),
                end: moment(res[0].DncValues[0].getFinalDate)
            };

            options.subtitle = `${options.subtitle} (${period.start.format('MMM/YYYY')} - ${period.end.format('MMM/YYYY')})`;
            let resToInfo = _.cloneDeep(res);

            const { models, competingClassification, channels, companySizes, salesType } = LayerControls('DncFlexible').getFilters();

            if (models || competingClassification || channels || companySizes || salesType) {
                const segments = models
                    ? models.text
                    : competingClassification && _.size(competingClassification.value)
                        ? _.flatMap(competingClassification.value, key => _.map(environment.get('CONFIG.FILTERS.COMPETING_SEGMENTS')[key], v => translateText(v.nome, true)))
                        : undefined;
                const idsSaleChannels = channels ? channels.value : undefined;
                const idsCompanySize = companySizes ? companySizes.value : undefined;
                const idsSalesType = salesType ? salesType.value : undefined;
                let data = [];

                if (resToInfo[0].DncValues) {
                    data = resToInfo[0].DncValues.filter(x =>
                        (!segments || segments.includes(x.nameSegment.toUpperCase()))
                        && (!idsSaleChannels || idsSaleChannels.includes(x.idSaleChannel))
                        && (!idsCompanySize || idsCompanySize.includes(x.companySize))
                        && (!idsSalesType || idsSalesType.includes(x.idSaleType)));

                    resToInfo[0].DncValues = data;
                }
            }

            const labelSaleType = '';
            const clientName = NeoGIG.Environment.get('CONFIG').CLIENT.toUpperCase();

            const dncValuesSegmentFamily =
                _(resToInfo)
                    .map(x => x.DncValues)
                    .flatten()
                    .groupBy('nameSegment')
                    .map((val, key) => {
                        const goal = val.reduce((acc, curr) => acc + curr.totalClient + (curr.dncValue * -1), 0);
                        const registrationIndustries = _.unionWith(val, (a, b) =>
                            a.totalIndustry === b.totalIndustry
                            && a.nameSegment === b.nameSegment
                            && a.companySize === b.companySize
                            && a.idSaleChannel === b.idSaleChannel);

                        return {
                            key,
                            goal,
                            registrationIndustry: _(registrationIndustries).sumBy('totalIndustry'),
                            dncValues: val,
                        };
                    });

            let dncValues = dncValuesSegmentFamily
                .map((val) => {
                    const registrationClient = _(val.dncValues).sumBy('totalClient');
                    const dncValueRaw = val.dncValues.reduce((acc, curr) => acc + curr.dncValue, 0);
                    const dncValue = Math.abs(dncValueRaw) < 1e-10 ? 0 : dncValueRaw;

                    return ({
                        Segmento: val.key,
                        Meta_DNC: dncValue,
                        Realizado_EmplacamentoIndustria: val.registrationIndustry,
                        Realizado_EmplacamentoCliente: registrationClient,
                        Meta_Emplacamento_Potencial: val.goal,
                        Meta_MarketShare: numeral(val.goal / val.registrationIndustry).format('0[.]0%'),
                        Realizado_MarketShare: numeral(registrationClient / val.registrationIndustry).format('0[.]0%')
                    });
                })
                .orderBy('Segmento', 'asc')
                .value();

            dncValues = dncValues.map(x => ({
                Segmento: x.Segmento,
                Meta_DNC: numeral(x.Meta_DNC).format('0,0'),
                Realizado_EmplacamentoIndustria: numeral(x.Realizado_EmplacamentoIndustria).format('0,0'),
                Realizado_EmplacamentoCliente: numeral(x.Realizado_EmplacamentoCliente).format('0,0'),
                Meta_Emplacamento_Potencial: numeral(x.Meta_Emplacamento_Potencial).format('0,0'),
                Meta_MarketShare: x.Meta_MarketShare,
                Realizado_MarketShare: x.Realizado_MarketShare
            }));

            this._treatMarketShareGreatherThan100Percent(dncValues, dncValuesSegmentFamily);

            const dncValuesNumber = dncValues.map(x => ({
                Meta_DNC: numeral(x.Meta_DNC).value(),
                Realizado_EmplacamentoIndustria: numeral(x.Realizado_EmplacamentoIndustria).value(),
                Realizado_EmplacamentoCliente: numeral(x.Realizado_EmplacamentoCliente).value(),
                Meta_Emplacamento_Potencial: numeral(x.Meta_Emplacamento_Potencial).value(),
                Meta_MarketShare: numeral(x.Meta_MarketShare).value(),
                Realizado_MarketShare: numeral(x.Realizado_MarketShare).value()
            }));

            dncValues = [...dncValues, {
                Segmento: 'TOTAL',
                Meta_DNC: dncValuesNumber.reduce((acc, curr) => acc + Math.round(curr.Meta_DNC), 0),
                Realizado_EmplacamentoIndustria: _(dncValuesNumber).sumBy('Realizado_EmplacamentoIndustria'),
                Realizado_EmplacamentoCliente: _(dncValuesNumber).sumBy('Realizado_EmplacamentoCliente'),
                Meta_Emplacamento_Potencial: _(dncValuesNumber).sumBy('Meta_Emplacamento_Potencial'),
                Meta_MarketShare: numeral(_(dncValuesNumber).sumBy('Meta_Emplacamento_Potencial') / _(dncValuesNumber).sumBy('Realizado_EmplacamentoIndustria')).format('0[.]0%'),
                Realizado_MarketShare: numeral(_(dncValuesNumber).sumBy('Realizado_EmplacamentoCliente') / _(dncValuesNumber).sumBy('Realizado_EmplacamentoIndustria')).format('0[.]0%')
            }];


            options.convertTable = false;
            options.size = '50%';
            options.columns = [
                {
                    field: 'Segmento',
                    title: translate('Common.Segment'),
                    width: 200
                },
                {
                    title: translate('Common.Potential'),
                    columns: [
                        {
                            title: 'A = (F-B)',
                            columns: [
                                {
                                    title: `DNC - ${translate('Common.UncapturedDemand')}`,
                                    field: 'Meta_DNC',
                                }
                            ]
                        },
                        {
                            title: 'B = (C*E)',
                            columns: [
                                {
                                    title: `${translate('Common.BrandPotentialRegistration')} ${clientName}`,
                                    field: 'Meta_Emplacamento_Potencial',
                                }
                            ]
                        },
                        {
                            title: 'C',
                            columns: [
                                {
                                    title: `${translate('Common.BrandMarketShare')} ${clientName}`,
                                    field: 'Meta_MarketShare',
                                }
                            ]
                        }
                    ]
                },
                {
                    title: translate('Common.Realized'),
                    columns: [
                        {
                            title: 'D = (F/E)',
                            columns: [
                                {
                                    title: `Market Share ${translate(labelSaleType)} ${clientName}`,
                                    field: 'Realizado_MarketShare',
                                }
                            ]
                        },
                        {
                            title: 'E',
                            columns: [
                                {
                                    title: translate('Common.RegistrationSaleType', { saleType: labelSaleType, type: `(${translate('Common.Industry')})` }),
                                    field: 'Realizado_EmplacamentoIndustria',
                                }
                            ]
                        },
                        {
                            title: 'F',
                            columns: [
                                {
                                    title: translate('Common.RegistrationSaleType', { saleType: labelSaleType, type: clientName }),
                                    field: 'Realizado_EmplacamentoCliente',
                                }
                            ]
                        }
                    ]
                }
            ];

            options.data = [dncValues];
            options.chart = false;

            options.buttons = {
                fullscreen: true,
            };

            options.container = '';

            return dataBoard.show(options);
        };

        const _error = error => {
            console.log(error);
        };

        if (_.size(entries))
            _success(entries);

        if (feature)
            _success([feature.properties]);
    }

    _treatMarketShareGreatherThan100Percent(dncValues, dncValuesSegmentFamily) {
        const getNumeralValue = (value) => numeral(value).value();

        if (!dncValues.some(x => getNumeralValue(x.Meta_MarketShare) > 1)) return;

        dncValues.forEach(x => {
            if (getNumeralValue(x.Meta_MarketShare) > 1) {
                const dncValueSegmentFamily = dncValuesSegmentFamily.value().find(y => y.key === x.Segmento);

                const dncValues = dncValueSegmentFamily.dncValues.map(y => {
                    const emplacamentoPotencial = y.registrationClient + (y.dncValue * -1);
                    const marketShareReference = emplacamentoPotencial / dncValueSegmentFamily.registrationIndustry;
                    const metaMarketShare = marketShareReference / getNumeralValue(x.Meta_MarketShare);
                    const metaEmplacamentoPotencial = metaMarketShare * dncValueSegmentFamily.registrationIndustry;
                    const dncValue = y.registrationClient - metaEmplacamentoPotencial;

                    return {
                        Meta_DNC: dncValue,
                        Meta_Emplacamento_Potencial: metaEmplacamentoPotencial,
                        Meta_MarketShare: metaMarketShare,
                    };
                });

                const metaEmplacamentoPotencial = _(dncValues).sumBy("Meta_Emplacamento_Potencial");

                x.Meta_DNC = numeral(_(dncValues).sumBy("Meta_DNC")).format('0,0');
                x.Meta_Emplacamento_Potencial = numeral(metaEmplacamentoPotencial).format('0,0');
                x.Meta_MarketShare = numeral(metaEmplacamentoPotencial / dncValueSegmentFamily.registrationIndustry).format('0[.]00%');
            }
        });
    }

    _showSummary(feature) {
        const options = {
            title: translate('Common.UnmetDemandBySegment'),
            themeId: 23, // LayerControls('DNC').getTheme(),
            typeId: LayerControls('DncFlexible').isNationalArea() ? LayerControls('DncFlexible').getType() : 1,
            startDate: LayerControls('DncFlexible').getDate().start.format('YYYYMM'),
            endDate: LayerControls('DncFlexible').getDate().end.format('YYYYMM'),
            grouping: !LayerControls('DncFlexible').isNationalArea(),
            // autoFitColumn: true,
            // message: translate(isAuthorized('dynamic-maps-dnc-expansion-view') ? 'Message.DNCCalc' : 'Message.DNCAltCalc'),
            periodo: environment.get('CONFIG.PARAM.DNC_DATES_PERIOD'),
            message: translate('Message.DNCAltCalc'),
            saleType: LayerControls('DncFlexible')._getLayerOptions().saleType
        };

        this._setSummary(options, feature, this.getSelectedEntries());
    }

    // @Override (super.Show -> ShapesInfo)
    show(container) {
        $(container).find('.panel-context').hide();

        if (this._status) {
            const disabled = this.getEntry().size === 0 ? 'disabled' : '';
            const $template = $(this._getTemplate('action-bar', {
                disabled,
                id: `${this.options.name}-submit`,
                reset: true
            }));
            $(container).append($template);

            $template.find('.action-submit').on('click', () => {
                return this._showSummary();
            });

            $template.find('.action-cancel').on('click', () => {
                return $('a[data-target="select_none"]').click();
            });
        }
    }

    reset() {
        this.getEntry().clear();
        this._selectedAreaId = undefined;

        const controls = LayerControls(this.options.name);

        if (controls.check()) {
            this.unhighlight(true);
            controls.reload();
        }
    }
}

export default DncFlexibleInfo;



// WEBPACK FOOTER //
// ./src/scripts/info/DncFlexibleInfo.js